export function isDebugMode(): boolean {
  return process.env.REACT_APP_DEBUG === "true";
}
